var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "special",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tools",
    transform: "translate(-666.000000, -269.000000)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(645.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sum_edit",
    transform: "translate(30.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,18 L5.25,20.25 L5.25,15.75 L2.25,15.75 C1.422,15.75 0.75,15.078 0.75,14.25 L0.75,2.25 C0.75,1.422 1.422,0.75 2.25,0.75 L18.75,0.75 C19.578,0.75 20.25,1.422 20.25,2.25 L20.25,6.75",
    id: "Path",
    stroke: "#F7B89E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 5.25,
    x2: 15.75,
    y2: 5.25,
    id: "Path",
    stroke: "#F7B89E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 9.75,
    x2: 8.25,
    y2: 9.75,
    id: "Path",
    stroke: "#F7B89E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F7B89E",
    points: "23.25 18.75 20.25 18.75 20.25 23.25 15.75 18.75 11.25 18.75 11.25 9.75 23.25 9.75"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.25,
    y1: 12.75,
    x2: 14.25,
    y2: 12.75,
    id: "Path",
    stroke: "#F7B89E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.25,
    y1: 15.75,
    x2: 14.25,
    y2: 15.75,
    id: "Path",
    stroke: "#F7B89E"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.b1cc4f2343e9bad85724277bb3e07289.svg";
export { ForwardRef as ReactComponent };